import { render, staticRenderFns } from "./SingleVenuesCopy.vue?vue&type=template&id=828cf8fa&scoped=true"
import script from "./SingleVenuesCopy.vue?vue&type=script&lang=js"
export * from "./SingleVenuesCopy.vue?vue&type=script&lang=js"
import style0 from "./SingleVenuesCopy.vue?vue&type=style&index=0&id=828cf8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828cf8fa",
  null
  
)

export default component.exports